/* eslint-disable jsx-a11y/href-no-hash */
/* eslint-disable jsx-a11y/anchor-has-content */
import React, { Component } from 'react';
import { connect } from 'react-redux';
// import logo from '../../../source/JOD-logo.png'
import logo from '../../../source/BRI_WABA_LOGO_NON_BG.png'
import { bindActionCreators } from 'redux';
import StoreActionLogout from '../../../store/action/LogoutAction'
import { PrevilageId, UserLoggedIn } from '../../../helper/HelperAuth';
import { fromJS } from 'immutable';
import ActionFindByGroupId from '../../../store/action/Previlage/FindByGroupId'

class LayoutHeaderComponent extends Component{
    constructor(props) {
        super(props);
        const user = UserLoggedIn;
        if(user){
            this.state = {
                open: false,
                openLeftNav:false,
                isLogout: false,
                isadmin:false,
                name: user.get('FullName'),
                sideBarStyle: true,
            };
        }else{
            this.state = {
                isadmin:false,
                open: false,
                openLeftNav:false,
                isLogout: false,
                name: ""
            };
        }
        
        this.toogleUserMenu = this.toogleUserMenu.bind(this);
        this.toogleUserMenuHide = this.toogleUserMenuHide.bind(this);
        this.handleLogout = this.handleLogout.bind(this);
        this.handleChangePassword = this.handleChangePassword.bind(this);
        this.handleProfile = this.handleProfile.bind(this);
    }

    
    toogleLeftBar(){   
        this.setState({ openLeftNav: !this.state.open })
    }
    toogleLeftBarHide(){
        this.setState({ openLeftNav: false })
    }
    toogleUserMenu(){   
        this.setState({ open: !this.state.open })
    }
    toogleUserMenuHide(){
        this.setState({ open: false })
    }

    async handleLogout(){
        await this.props.ActionLogout();

    }

    handleChangePassword(){
        window.location = '/changepassword';
    }

    handleResetPassword(){
        window.location = '/resetpassword';
    }

    handleProfile(){
        window.location = '/waprofilesetting';
    }

    async componentDidMount(){
        var isAdmin = await this.props.actionFindByGroupId()
        this.setState({isadmin:isAdmin})
    }

    render(){
        const open = (this.state.open) ? "open" : "" ;
        const hideReset = (this.state.isadmin || PrevilageId == 1) ? "" :"hide"
        return(
            <div className="top-bar">
            <div className="top-bar__container">
                <div className="top-bar__section top-bar--left">
                    <div className="top-bar__item top-bar--burger">
                        <div className="burger__outer" onClick={this.props.handleTopBarClicked}>
                            <span className="hide-for-large-up">
                                <a
                              className="burger">
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                </a>
                            </span>
                            <span
                              className="show-for-large-up">
                                <a className="burger">
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                </a>
                            </span>
                        </div>
                    </div>
                    <div className="top-bar__item top-bar--logo">
                        <a href="/home">
                            <img src={ logo } alt="SATKOM One Dashboard" />
                        </a>
                    </div>
                </div>
                <div className="top-bar__section top-bar--right">
                    <div className="top-bar__item top-bar--profile">
                        <div className="v-popover">
                            <span aria-describedby="popover_mck2gpeqcz" tabIndex="-1" className="trigger">
                                <span className="show-for-medium-up">
                                    <a className="tooltip-target text--dropdown" onClick={ this.toogleUserMenu }>
                                        <span>{ this.state.name }</span>
                                        <span className="text--arrow">
                                            <span className="text--arrow-inner">
                                                <svg role="presentation" width="10" height="16" viewBox="0 0 320 512" className="fa-icon">
                                                    <path d="M143 352.3L7 216.3C-2.4 206.9-2.4 191.7 7 182.4L29.6 159.8C39 150.4 54.2 150.4 63.5 159.8L159.9 256.2 256.3 159.8C265.7 150.4 280.9 150.4 290.2 159.8L312.8 182.4C322.2 191.8 322.2 207 312.8 216.3L176.8 352.3C167.6 361.7 152.4 361.7 143 352.3z"></path>
                                                </svg>
                                            </span>
                                        </span>
                                    </a>
                                    <li className={"dropdown "+open}>
                                        <ul className="dropdown-menu pull-right">
                                            {/* <li>
                                                <a onClick={ this.handleProfile}  href="#" className="waves-effect waves-red">
                                                    <i className="material-icons">person</i>Profile
                                                
                                                </a>
                                            </li> */}
                                            <li>
                                                <a onClick={ this.handleChangePassword }  href="#" className="waves-effect waves-red">
                                                    <i className="material-icons">lock</i>Change Password
                                                
                                                </a>
                                            </li>
                                            {/* <li className={`${hideReset}`}>
                                                <a onClick={ this.handleResetPassword }  href="#" className="waves-effect waves-red">
                                                    <i className="material-icons">autorenew</i>Reset Password
                                                
                                                </a>
                                            </li> */}
                                            <li role="separator" className="divider"></li>
                                            <li>
                                                <a onClick={ this.handleLogout } href="#" className="waves-effect waves-red">
                                                    <i className="material-icons">input</i>Sign Out
                                                </a>
                                            </li>
                                        </ul>
                                    </li>
                                </span>
                                <span className="hide-for-medium-up">
                                    <a className="tooltip-target" onClick={ this.toogleUserMenu }>
                                        <span className="top-bar__icon">
                                            <svg role="presentation" width="6" height="16" viewBox="0 0 192 512" className="fa-icon">
                                                <path d="M96 184C135.8 184 168 216.2 168 256S135.8 328 96 328 24 295.8 24 256 56.2 184 96 184zM24 80C24 119.8 56.2 152 96 152S168 119.8 168 80 135.8 8 96 8 24 40.2 24 80zM24 432C24 471.8 56.2 504 96 504S168 471.8 168 432 135.8 360 96 360 24 392.2 24 432z"></path>
                                            </svg>
                                        </span>
                                    </a>
                                    <li className={"dropdown "+open}>
                                        <ul className="dropdown-menu pull-right">
                                            <li>
                                                <a href="#" className="waves-effect waves-red">
                                                    <i className="material-icons">person</i>Profile
                                                
                                                </a>
                                            </li>
                                            <li>
                                                <a onClick={ this.handleChangePassword }  href="#" className="waves-effect waves-red">
                                                    <i className="material-icons">lock</i>Change Password
                                                
                                                </a>
                                            </li>
                                            <li role="separator" className="divider"></li>
                                            <li>
                                                <a onClick={ this.handleLogout } href="#" className="waves-effect waves-red">
                                                    <i className="material-icons">input</i>Sign Out
                                                </a>
                                            </li>
                                        </ul>
                                    </li>
                                </span>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
            );
    }
}

export default connect(
    (state) => {
        return {
            loggedInUser: state.auth.loggedInUser,
        }
    },
    dispatch => bindActionCreators({
        ActionLogout: StoreActionLogout,
        actionFindByGroupId:ActionFindByGroupId
    }, dispatch),
)(LayoutHeaderComponent);